import http from '../../../services/api'
import type { APIResponse } from '../../../services/types'
import type { ItemUnitApi, ItemUnitCreateInput, ItemUnitUpdateInput } from '../types'

const apiPath = import.meta.env.VITE_API_PATH

function itemUnitsPath(itemUuid: string): string {
  return `${apiPath}items/${itemUuid}/units`
}

async function getItemUnits(itemUuid: string) {
  return await http.get<APIResponse<ItemUnitApi[]>>(itemUnitsPath(itemUuid))
}

async function addItemUnit(itemUuid: string, input: ItemUnitCreateInput) {
  const payload = {
    unit_uuid: input.unit_uuid,
    ...(input.barcode !== undefined ? { barcode: input.barcode || null } : {}),
    ...(input.is_default_sales !== undefined ? { is_default_sales: input.is_default_sales } : {}),
    ...(input.is_default_purchase !== undefined ? { is_default_purchase: input.is_default_purchase } : {}),
  }
  return await http.post<APIResponse<ItemUnitApi>>(itemUnitsPath(itemUuid), payload)
}

async function updateItemUnit(itemUuid: string, unitRef: string, input: ItemUnitUpdateInput) {
  return await http.put<APIResponse<ItemUnitApi>>(`${itemUnitsPath(itemUuid)}/${unitRef}`, input)
}

async function removeItemUnit(itemUuid: string, unitRef: string) {
  return await http.delete<APIResponse<null>>(`${itemUnitsPath(itemUuid)}/${unitRef}`)
}

const itemUnitsService = {
  getItemUnits,
  addItemUnit,
  updateItemUnit,
  removeItemUnit,
}

export default itemUnitsService
